import { formatBytes } from "@/lib/format";

interface FolderSummaryProps {
  currentPath: string;
  fileCount: number;
  folderCount: number;
  totalBytes: number;
}

const folderLabel = (currentPath: string) => {
  if (currentPath === "/") return "Root";
  const parts = currentPath.split("/").filter(Boolean);
  return parts[parts.length - 1] ?? "Root";
};

export const FolderSummary = ({
  currentPath,
  fileCount,
  folderCount,
  totalBytes,
}: FolderSummaryProps) => {
  const parts: string[] = [
    `${fileCount} ${fileCount === 1 ? "file" : "files"}`,
  ];
  if (folderCount > 0) {
    parts.push(`${folderCount} ${folderCount === 1 ? "folder" : "folders"}`);
  }

  return (
    <div>
      <h2 className="text-lg font-semibold">
        {folderLabel(currentPath)} folder — {parts.join(", ")}
        {totalBytes > 0 && (
          <span className="text-muted-foreground font-normal">
            {" "}
            · {formatBytes(totalBytes)}
          </span>
        )}
      </h2>
      <p className="text-sm text-muted-foreground">Current path: {currentPath}</p>
    </div>
  );
};
